var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,0c-2.76,0-5,2.24-5,5v17H5c-2.76,0-5,2.24-5,5s2.24,5,5,5h17v17c0,2.76,2.24,5,5,5s5-2.24,5-5v-17h17c2.76,0,5-2.24,5-5s-2.24-5-5-5h-17V5c0-2.76-2.24-5-5-5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.3c18f551bba492c1c3cc58f4abb5aa48.svg";